<template>
	<section id="home-search" :class="eventos.length === 0 && !isCargandoEventos ? 'no-featured-events' : ''">
		<div class="scroll-down">
			<i class='bx bxs-down-arrow-alt'></i>
		</div>
		<!-- <div class="blurred-bg"></div> -->
		<!-- <div class="blurred-bg-2"></div> -->
		<div class="container home-search-content">
			<div class="home-search-left">
				<!-- <h1>LineUp.</h1>
				<h1 class="be-there">Be There.</h1> -->
				<img src="../assets/lineup-hero2.svg" alt="LineUp Tickets" class="logo-hero">
				<p>Tu boleto de entrada a los eventos más emocionantes. Busca eventos por nombre, ciudad, artista, equipo, competición.</p>
				<div class="search-box" @click="$store.dispatch('showIsSearching')">
					<i class='search-icon bx bx-search'></i>
					<span class="search-placeholder">Busca por ciudad, artista, equipo, competición</span>
					<button class="search-button">Buscar</button>
				</div>
			</div>
			<div class="home-search-right">
				<div class="column">
					<span class="tendencia-text">Tendencia ahora</span>
					<SkeletonEventoTendencia class="tendencia-item" v-if="isCargandoEventos" />
					<!-- <kinesis-container>
						<kinesis-element :strength="16" type="depth" class="kinesis-element"> -->
							<EventCard :evento="eventos[0]" @click="irAEvento(eventos[0].Evento.EventoId, eventos[0].Evento.EventoSlug)" v-if="!isCargandoEventos && eventos.length > 0" />
						<!-- </kinesis-element>
					</kinesis-container> -->
				</div>
				<div class="column" v-if="isCargandoEventos || eventos.length > 1">
					<SkeletonEventoTendencia class="tendencia-item" v-if="isCargandoEventos" />
					<!-- <kinesis-container>
						<kinesis-element :strength="16" type="depth" class="kinesis-element"> -->
							<EventCard :evento="eventos[1]" @click="irAEvento(eventos[1].Evento.EventoId, eventos[1].Evento.EventoSlug)" v-if="!isCargandoEventos && eventos.length > 1" />
						<!-- </kinesis-element>
					</kinesis-container> -->
				</div>
				<div class="column column-ticketin" v-if="eventos.length <= 1 && !isCargandoEventos">
					<img src="../assets/ticketin/Defecto.svg" alt="LineUp Tickets" class="featured-ticketin">
				</div>
			</div>
		</div>
		<!-- <div class="container">
			<confian-en-nosotros></confian-en-nosotros>
		</div> -->
	</section>
</template>

<script>
	import axios from 'axios'
	import EventCard from "../components/eventos/EventCard.vue";
	// import EventCardAux from "../components/eventos/EventCardAux.vue";
	import SkeletonEventoTendencia from '../components/skeletons/SkeletonEventoTendencia.vue'
	// import ConfianEnNosotros from '../components/ConfianEnNosotros.vue'

	// import { KinesisContainer, KinesisElement} from 'vue-kinesis'

	export default {
		data(){
			return {
				eventos: [],
				isCargandoEventos: true,
			}
		},
		components: {
			EventCard,
			SkeletonEventoTendencia,
			// ConfianEnNosotros

			// KinesisContainer,
			// KinesisElement
		},
		async mounted(){
			await this.getFeaturedEvents();
		},
		methods: {
			async getFeaturedEvents(){
				try {
					this.isCargandoEventos = true
					this.eventos = []

					let response = await axios.post('/WSEventosDestacados', {
						IsDesdeRedpagos: false
					});

					if(response.data.ErrorCod === 0){
						this.eventos = response.data.SDTEventos
					}
				} catch (error) {
					console.log('Ocurrió un error al cargar los eventos');
				} finally {
					this.isCargandoEventos = false
				}
			},
			irAEvento(id, slug) {
				this.$router.push({ name: 'evento', params: { eventSlug: slug, eventId: id } });
			},
		}
	}
</script>

<style lang="scss" scoped>
	#home-search{
		position: relative;
		width: 100%;
		@include flex(column, center, center);
		// min-height: 900px;
		padding: 60px 0px 115px 0px;
		// top: calc(-1 * var(--height-header));
		background-color: var(--color-secondary);

		&.no-featured-events{
			min-height: 550px;
			
			.home-search-content{
				@include flex(row, center, center);

				.home-search-left{
					width: 56%;
					@include flex(column, center, center);

					p{
						width: 100%;
						text-align: center;
					}
				}

				.home-search-right{
					display: none;
				}
			}
		}

		.blurred-bg{
			--size: 450px;
			--speed: 30s;
			--easing: cubic-bezier(0.8, 0.2, 0.2, 0.8);

			position: absolute;
			height: var(--size);
			width: var(--size);
			opacity: 0.3;
			aspect-ratio: 1/1;
			left: 0;
			transform: translate(-50%, -50%);
			filter: blur(calc(var(--size) / 6));
			background-image: linear-gradient(var(--color-primary), var(--color-blue-link));
			animation: rotate var(--speed) var(--easing) alternate infinite;
			border-radius: 30% 70% 70% 30% / 30% 30% 70% 70%;

			@keyframes rotate {
				0% {
					transform: rotate(0deg);
				}
				100% {
					transform: rotate(360deg);
				}
			}
		}

		.blurred-bg-2{
			--size: 450px;
			--speed: 30s;
			--easing: cubic-bezier(0.8, 0.2, 0.2, 0.8);

			position: absolute;
			height: var(--size);
			width: var(--size);
			opacity: 0.3;
			aspect-ratio: 1/1;
			right: 0;
			bottom: 0;
			transform: translate(-50%, -50%);
			filter: blur(calc(var(--size) / 6));
			background-image: linear-gradient(var(--color-primary), var(--color-blue-link));
			animation: rotate var(--speed) var(--easing) alternate infinite;
			border-radius: 30% 70% 70% 30% / 30% 30% 70% 70%;

			@keyframes rotate {
				0% {
					transform: rotate(0deg);
				}
				100% {
					transform: rotate(360deg);
				}
			}
		}

		.scroll-down{
			position: absolute;
			left: 50px;
			bottom: 50px;
			height: 60px;
			width: 34px;
			border: 1px solid #666666;
			border-radius: 22px;
			@include flex(row, center, center);

			i{
				margin-top: 10px;
				color: var(--color-white);
				animation: bounce 2s infinite;
				-webkit-animation: bounce 2s infinite;
				-moz-animation: bounce 2s infinite;
				-o-animation: bounce 2s infinite;
			}

			@-webkit-keyframes bounce {
				0%, 20%, 50%, 80%, 100% {-webkit-transform: translateY(0);}	
				40% {-webkit-transform: translateY(-15px);}
				60% {-webkit-transform: translateY(-7px);}
			}
			
			@-moz-keyframes bounce {
				0%, 20%, 50%, 80%, 100% {-moz-transform: translateY(0);}
				40% {-moz-transform: translateY(-15px);}
				60% {-moz-transform: translateY(-7px);}
			}
			
			@-o-keyframes bounce {
				0%, 20%, 50%, 80%, 100% {-o-transform: translateY(0);}
				40% {-o-transform: translateY(-15px);}
				60% {-o-transform: translateY(-7px);}
			}
			@keyframes bounce {
				0%, 20%, 50%, 80%, 100% {transform: translateY(0);}
				40% {transform: translateY(-15px);}
				60% {transform: translateY(-7px);}
			}
		}

		.home-search-content{
			position: relative;
			padding-top: 40px;
			@include flex(row, space-between, center);

			.home-search-left{
				position: relative;
				top: -40px;
				width: 46%;
				padding-left: 44px;
				padding-right: 44px;
				@include flex(column, flex-start, flex-start);

				.logo-hero{
					margin-bottom: 30px;
					height: 150px;
					width: auto;
					user-select: none;
					-moz-user-select: none;
					-webkit-user-drag: none;
					-webkit-user-select: none;
					-ms-user-select: none;
				}

				.blurred-shape{
					position: absolute;
					top: -140px;
					left: 100px;
					user-select: none;
					width: 500px;
					height: auto;
					-moz-user-select: none;
					-webkit-user-drag: none;
					-webkit-user-select: none;
					-ms-user-select: none;
					z-index: -1;
				}

				// h1{
				// 	font-size: 96px;
				// 	font-family: var(--font-sora);
				// 	font-weight: var(--fw-800);
				// 	color: var(--color-white);
				// 	margin-bottom: 0px;
				// 	line-height: 1.15em;
				// 	position: relative;
				// 	z-index: 1;
				// 	text-shadow: 4px 4px 2px rgba(0, 0, 0, 0.1);

				// 	&.be-there{
				// 		font-size: 56px;
				// 		margin-bottom: 20px;
				// 		color: var(--color-primary);
				// 		padding-left: 4px;
				// 		text-shadow: 4px 4px 2px rgba(0,0,0,0.1);

				// 		&::before{
				// 			content: 'Be There.';
				// 			position: absolute;
				// 			top: -6px;
				// 			left: 0px;
				// 			text-align: center;
				// 			font-family: var(--font-sora);
				// 			color: var(--color-white);
				// 			font-size: 56px;
				// 			font-weight: var(--fw-800);
				// 			line-height: 1.15em;
				// 			@include flex(row, center, center);
				// 			// background-color: rgba(0, 0, 0, 0.3);
				// 			z-index: 1;

				// 		}
				// 	}
				// }

				p{
					font-size: 18px;
					font-weight: var(--fw-300);
					line-height: 1.6em;
					color: var(--color-white);
					margin: 0;
				}

				.search-box{
					position: relative;
					margin-top: 30px;
					width: 100%;
					border-radius: 24px;
					background-color: var(--color-white);
					border: none;
					box-shadow: rgba(36, 63, 97, 0.12) 0px 3px 20px, rgba(36, 63, 97, 0.08) 0px 1.5px 4px;
					@include flex(row, space-between, center);

					.search-icon{
						color: #666666;
						font-size: 22px;
						position: absolute;
						margin: 0px;
						top: 50%;
						transform: translateY(-50%);
						left: 20px;
					}

					.search-placeholder{
						padding: 20px 20px 20px 60px;
						width: calc(100% - var(--height-header));
						background: transparent;
						font-size: 14px;
						color: #666666;
						line-height: 1em;
						cursor: pointer;
						@include transition(all .2s);
					}

					.search-button{
						background-color: var(--color-primary);
						border-radius: 24px;
						height: 40px;
						color: var(--color-darker);
						font-family: var(--font-sora);
						outline: none;
						border: none;
						padding: 0px 20px;
						margin-right: 10px;
						font-size: 11px;
						font-weight: var(--fw-600);
						line-height: 1em;
						text-transform: uppercase;
						letter-spacing: 0.5px;
						@include transition(all .2s);
						cursor: pointer;

						&:hover{
							opacity: 0.9;
						}
					}
				}
			}

			.home-search-right{
				width: 48%;
				position: relative;
				top: -40px;
				@include flex(row, space-between, flex-end);

				.column{
					width: calc(50% - 8px);
					height: 100%;
					@include flex(column, center, flex-end);

					span.tendencia-text{
						font-size: 11px;
						font-weight: var(--fw-300);
						letter-spacing: 2px;
						font-family: var(--font-sora);
						color: var(--color-white);
						text-transform: uppercase;
						padding: 10px;
						width: 100%;
					}

					.featured-ticketin{
						width: 80%;
					}
				}
			}
		}
	}

	@media screen and (max-width: 1400px){
		#home-search{
			padding: 60px 0px;
			min-height: auto;

			.scroll-down{
				display: none;
			}

			.blurred-bg-2{
				display: none;
			}

			.home-search-content{
				padding-top: 0px;
				padding-left: 24px;
				padding-right: 24px;

				.home-search-left{
					width: 48%;
					padding-left: 0px;
					padding-right: 20px;
					top: 0px;

					.logo-hero{
						margin-bottom: 26px;
						height: 120px;
					}

					// h1{
					// 	font-size: 77px;

					// 	&.be-there{
					// 		font-size: 45px;
					// 		margin-bottom: 15px;

					// 		&::before{
					// 			font-size: 45px;
					// 		}
					// 	}
					// }

					p{
						font-size: 16px;
						max-width: 520px;
					}

					.search-box{
						margin-top: 20px;
						max-width: 520px;
					}
				}

				.home-search-right{
					width: 52%;

					.column{
						span.tendencia-text{
							font-size: 11px;
						}
					}
				}
			}
		}
	}

	@media screen and (max-width: 1120px){
		#home-search{
			.home-search-content{
				.home-search-left{
					width: 44%;
					padding-right: 20px;

					.logo-hero{
						margin-bottom: 20px;
						height: 120px;
					}

					// h1{
					// 	font-size: 62px;

					// 	&.be-there{
					// 		font-size: 36px;
					// 		margin-bottom: 12px;

					// 		&::before{
					// 			font-size: 36px;
					// 			top: -4px;
					// 		}
					// 	}
					// }

					p{
						font-size: 15px;
					}

					.search-box{
						margin-top: 20px;

						.search-placeholder{
							text-overflow: ellipsis;
							white-space: nowrap;
							overflow: hidden;
						}
					}
				}

				.home-search-right{
					width: 56%;

					.column{
						span.tendencia-text{
							font-size: 11px;
						}
					}
				}
			}
		}
	}

	@media screen and (max-width: 1040px){
		#home-search{
			padding: 80px 0px 65px 0px;

			.home-search-content{
				@include flex(column, center, center);

				.home-search-left{
					width: 60%;
					padding-right: 0px;
					margin-bottom: 40px;

					.logo-hero{
						margin-bottom: 26px;
						height: 130px;
					}

					// h1{
					// 	font-size: 77px;

					// 	&.be-there{
					// 		font-size: 45px;
					// 		margin-bottom: 15px;

					// 		&::before{
					// 			font-size: 45px;
					// 		}
					// 	}
					// }

					p{
						font-size: 16px;
					}

					.search-box{
						margin-top: 20px;

						.search-placeholder{
							text-overflow: ellipsis;
							white-space: nowrap;
							overflow: hidden;
						}
					}
				}

				.home-search-right{
					width: 74%;
					padding-top: 30px;
					@include flex(column, center, center);

					.column{
						span.tendencia-text{
							font-size: 12px;
						}

						&.column-ticketin{
							display: none;
						}
					}
				}
			}
		}
	}

	@media screen and (max-width: 800px){
		#home-search{
			padding: 60px 0px 65px 0px;

			.home-search-content{
				.home-search-left{
					width: 100% !important;
					padding-right: 0px;
					margin-bottom: 40px;

					.logo-hero{
						margin-bottom: 20px;
						height: 90px;
					}

					// h1{
					// 	font-size: 62px;

					// 	&.be-there{
					// 		font-size: 36px;
					// 		margin-bottom: 12px;

					// 		&::before{
					// 			font-size: 36px;
					// 			top: -4px;
					// 		}
					// 	}
					// }

					p{
						font-size: 15px;
					}

					.search-box{
						margin-top: 14px;

						.search-placeholder{
							padding: 17px 20px 17px 60px;
							font-size: 13px;
						}

						.search-button{
							height: 34px;
							padding: 0px 17px;
						}
					}
				}

				.home-search-right{
					width: 100%;
					max-width: 380px;
					@include flex(column, center, center);

					.column{
						width: 100%;
						margin-bottom: 20px;

						.evento{
							min-height: unset;
							// aspect-ratio: 6/8;
							aspect-ratio: unset;
						}

						&:last-child{
							margin-bottom: 0px;
						}
					}
				}
			}

			&.no-featured-events{
				min-height: unset;
			}
		}
	}

	@media screen and (max-width: 580px){
		#home-search{
			padding: 60px 0px 65px 0px;

			.home-search-content{
				.home-search-right{
					width: 100%;
					padding-top: 20px;

					.column{
						span.tendencia-text{
							font-size: 11px;
						}
					}
				}
			}
		}
	}

	@media (pointer: coarse)  {
		#home-search{
			.home-search-content{
				.home-search-right{
					.column{
						.kinesis-element{
							transform: none !important;
						}
					}
				}
			}
		}
	}
</style>